import { render, staticRenderFns } from "./CancelPrescriptionForm.vue?vue&type=template&id=76042eac"
import script from "./CancelPrescriptionForm.vue?vue&type=script&lang=js"
export * from "./CancelPrescriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports